var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 598,
    height: 424,
    viewBox: "0 0 598 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M566.219 107C709.219 215.5 322.219 454.5 117.525 420C43.7187 407.56 -8.97474 277 1.52502 193.5C1.52502 165.886 25.3466 18.5173 192.191 4.97472C235 1.5 392.305 -24.9553 566.219 107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRock1);
export default __webpack_public_path__ + "static/media/rock1.8437fb36775a1c1b47ea555a954a1530.svg";
export { ForwardRef as ReactComponent };